import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalizeString' })
export class CapitalizeStringPipe implements PipeTransform {
  transform(val: string, args?: string) {
    if (!val) {
      return val;
    }
    return val[0].toUpperCase() + val.substr(1).toLowerCase();
  }
}
